module.exports = __webpack_public_path__ + "static/media/bolso (23).4be700fd.jpg";